import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../constants/GlobalStyles';
import NewDoctorForm from '../components/users/NewDoctorForm';
import { patientFormType } from '../components/config/variables';

const NewDoctor = () => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      <NewDoctorForm type={patientFormType.create}/>
    </motion.div>
  );
};

export default NewDoctor;
